import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueFirestore from 'vue-firestore'
import Firebase from 'firebase'
require('firebase/firestore')

Vue.use(VueFirestore)
var firebaseApp = Firebase.initializeApp({
    apiKey: "AIzaSyBooILNU7OvKNOOdc2I-oAl6UUDwWwg0-U",
    authDomain: "akb48-53rd.firebaseapp.com",
    databaseURL: "https://akb48-53rd.firebaseio.com",
    projectId: "akb48-53rd",
    storageBucket: "akb48-53rd.appspot.com",
    messagingSenderId: "248152664296"
  })

const firestore = firebaseApp.firestore();

function noop() {}
if (process.env.NODE_ENV === 'production '){
  console.log = noop;
  console.warn = noop;
  console.error = noop;
}


Vue.config.productionTip = false

new Vue({
  router,
  store,
  firestore(){
    return{
      members: firestore.collection('member'),
    }
  },
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js